<template>
  <div class="container">
    <div class="row align-items-center">
      <div class="offset-md-2 col-md-4 app-name">
        Microsoft Teams
      </div>
      <div class="col-md-4">
        <!-- NOTE: 公開されたら消す -->
        The button will be activated when the app is listed in AppSource.<br>
        <button
          type="button"
          class="btn btn-outline-neutral-primary"
          @click="openTeamsAppLink"
        >
          <i class="fab fa-microsoft" />
          Add to Microsoft Teams
        </button>
      </div>
    </div>
    <div class="row align-items-center">
      <div class="offset-md-2 col-md-4 app-name">
        Slack
      </div>
      <div class="col-md-4">
        <a @click="openSlackAppLink">
          <img
            alt="Add to Slack"
            height="40"
            width="139"
            src="https://platform.slack-edge.com/img/add_to_slack.png"
          >
        </a>
      </div>
    </div>
  </div>
</template>

<script>
import { ADD_TO_SLACK_LINK, ADD_TO_TEAMS_LINK } from '@/config/constants'

export default {
  methods: {
    openSlackAppLink() {
      open(ADD_TO_SLACK_LINK, '_blank')
    },
    openTeamsAppLink() {
      // open(ADD_TO_TEAMS_LINK, '_blank')
      alert('The button will be activated when the app is listed in AppSource.')
      console.log('ADD_TO_TEAMS_LINK', ADD_TO_TEAMS_LINK)
    }
  }
}
</script>

<style lang="scss" scoped>
.app-name {
  background-color: rgba(38, 33, 96, 0.25);
}
</style>
